module.exports = __webpack_public_path__ + "static/media/person6.ad57f6b4.png";